import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";

@Component({
    selector: "pa-sso",
    templateUrl: "./sso.component.html",
    styleUrls: ["./sso.component.scss"],
    standalone: false
})
export class SsoComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.sso();
  }
}
